import { getPath } from '@/router/common'

const baseUrl = {
  title: '运单审核',
  path: 'Billing'
}

export default [
  {
    path: getPath('unitCheck', baseUrl),
    name: 'Billing_unitCheck',
    component: () => import(/* webpackChunkName: "Billing_unitCheck" */ '@/views/billing/unitCheck/index.vue'),
    meta: {
      title: '运单审核'
    }
  },
  {
    path: getPath('CancelBill', baseUrl),
    name: 'Billing_CancelBill',
    component: () => import(/* webpackChunkName: "Billing_CancelBill" */ '@/views/billing/cancelBill/index.vue'),
    meta: {
      title: '运单作废'
    }
  },
  {
    path: getPath('AccCheck', baseUrl),
    name: 'Billing_AccCheck',
    component: () => import(/* webpackChunkName: "Billing_AccCheck" */ '@/views/billing/accCheck/index.vue'),
    meta: {
      title: '费用审核'
    }
  },
  {
    path: getPath('ReturnBill', baseUrl),
    name: 'Billing_ReturnBill',
    component: () => import(/* webpackChunkName: "Billing_ReturnBill" */ '@/views/billing/returnBill/index.vue'),
    meta: {
      title: '原货返回'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'Billing_Index',
    component: () => import(/* webpackChunkName: "Billing_Index" */ '@/views/billing/index/index.vue'),
    meta: {
      title: '修改运单'
    }
  },
  {
    path: getPath('FastIndex', baseUrl),
    name: 'Fast_Billing_Index',
    component: () => import(/* webpackChunkName: "Fast_Billing_Index" */ '@/views/billing/fastIndex/index.vue'),
    meta: {
      title: '修改运单'
    }
  },
  {
    path: getPath('CustomConfig', baseUrl),
    name: 'Bill_Custom_Config',
    component: () => import(/* webpackChunkName: "Bill_Custom_Config" */ '@/views/billing/billCustomConfig/index.vue'),
    meta: {
      title: '开单自定义配置'
    }
  },
  {
    path: getPath('DeliveryFeeCheck', baseUrl),
    name: 'Bill_DeliveryFeeCheck',
    component: () => import(/* webpackChunkName: "Bill_DeliveryFeeCheck" */ '@/views/billing/deliveryFeeCheck/record/index.vue'),
    meta: {
      title: '末端成本审批'
    }
  }
]
